import { usePersisted } from "./persisted";

/** Device-local preferences — the four knobs in the Settings sheet. */
export interface Settings {
  /** Scale of the countdown gauge, in months. Affects only how full each rail
   *  looks — never the sort order. */
  targetMonths: number;
  /** The "spoke recently" filter hides anyone who spoke within this many. */
  recentMonths: number;
  /** Empty speaker slots on a new meeting. */
  speakerSlots: number;
  /** Warn when picking someone who prayed within this many months. */
  prayerWarnMonths: number;
}

export const DEFAULT_SETTINGS: Settings = {
  targetMonths: 12,
  recentMonths: 6,
  speakerSlots: 2,
  prayerWarnMonths: 3,
};

export function useSettings() {
  const { value, set } = usePersisted("sacrament.settings.v1", DEFAULT_SETTINGS);
  return { settings: value, set };
}
